
import { Component, OnInit, EventEmitter, DebugEventListener, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';

import { Document_Upload_File } from '../../../models/common';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { RFI } from 'src/app/models/um/organization';
import * as $ from 'jquery';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { UserService } from '../../../services/user.service';
import { serviceConstants, deliveryFormatOptionsConstant } from 'src/app/constants/service.constants';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rfi-add-modal',
  templateUrl: './rfi-add-modal.component.html',
  styleUrls: ['./rfi-add-modal.component.scss']
})
export class RfiAddModalComponent implements OnInit {
  @Input() public Content: any;
  uploadedFiles = [];
  formFields;
  rowData;
  content: any;
  userType:string;
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  SavedAttachments = [];
  Cancel:string ="Cancel";
Status: string;
  document_attach_list: Document_Upload_File[] = [];
  rfiNewForm = new UntypedFormGroup({
    TITLE: new UntypedFormControl(null),
    DETAILS: new UntypedFormControl(null)
  });

  heading: string;
  action: Subject<any> = new Subject();
  rfi: RFI;

  constructor(
    public modalRef: NgbActiveModal,
    private commonService: CommonService,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private FileService: IstSummaryService,
    private userservice: UserService
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.userType =this.Content.content.usertype;
    if (this.Content.content && this.Content.content.id) { // Edit mode
      if(this.Content.content.rfiDetails == null || this.Content.content.rfiDetails == undefined){
        this.summaryService.getRFIByID('api/rfi/getrfibyid/' + this.Content.content.id).subscribe((result) => {
          this.setForm(result);
          if (this.Content.heading === 'View') {
            setTimeout(() => {
            }, 100);
            this.rfiNewForm.disable();
            this.Cancel ="Close";
          }
        });
      }else{
        this.setForm(this.Content.content.rfiDetails);
          if (this.Content.heading === 'View') {
            setTimeout(() => {
            }, 100);
            this.rfiNewForm.disable();
            this.Cancel ="Close";
          }
      }
    }
    else {
      this.rfi = new RFI();
      this.rfi.MODULE_ID = this.commonService.getModuleId(this.Content.content.module);
      this.rfi.APPLICATION_ID = this.Content.content.appid;
      this.setForm(this.rfi);
    }
  };

  setForm(result: RFI): void {
    this.rfiNewForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      MODULE_ID: new UntypedFormControl(result.MODULE_ID),
      APPLICATION_ID: new UntypedFormControl(result.APPLICATION_ID),
      TITLE: new UntypedFormControl(result.TITLE),
      DETAILS: new UntypedFormControl(result.DETAILS)
    });
    
    this.document_attach_list = [];
    if (result.Attachments !== undefined && result.Attachments !== null && result.Attachments.length !== 0) {
      for (let i = 0; i < result.Attachments.length; i++) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = result.Attachments[i].ID;
        uploadFile.DOCUMENT_NAME = result.Attachments[i].DOCUMENT_NAME;
        uploadFile.Status = "Edit";
        this.document_attach_list.push(uploadFile);
      }
    }
  }

  private getForm(): RFI {

    const formModel = this.rfiNewForm.value;

    let rfi = new RFI();
    rfi = {
      ID: formModel.ID || '',
      MODULE_ID: formModel.MODULE_ID || '',
      APPLICATION_ID: formModel.APPLICATION_ID || '',
      TITLE: formModel.TITLE || '',
      DETAILS: formModel.DETAILS || '',
      STATUS: 1,
      CreatedDateStr: '',
      Days: 0,
      RaisedBy: '',
      RECORD_STATE: 0,
      Attachments:[]
    };

    return rfi;
  }
  DeleteUpload(file): void {
 
    let code = file.ID;
    if (file.Status == "Add" || file.Status == "Edit") {
      this.document_attach_list = this.document_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
    // if (file.Status == "Add") {      
    //   this.document_attach_list = this.document_attach_list.filter(function (sec) {
    //     return sec.ID != code;
    //   }, code);
    // }
    // else {
    //   this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x)=>{
    //     if(x["Status"]==2 && x["Data"]==false)
    //     {
    //       this.commonService.ValidationBanner(x["Message"]);
    //     }
    //     else{
    //       this.document_attach_list = this.document_attach_list.filter(function (sec) {
    //         return sec.ID != code;
    //       }, code);
    //       file.Status = "Delete";
    //     }
    //   });
   
    // }
  }

  downloadFile(ID) {
     
    let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
    window.open(url);
  }

  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");
    }

    isAllowedExtensionFile(Filename)
  {
    return this.commonService.isAllowedExtension(Filename);
  }

  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    //let hasUnFormat = false;
    let Isexe = false;
    let Is5oMB = false;
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;
        //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else
      {
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = this.document_attach_list.filter(x=> x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if(hasValue.length > 0)
        {
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
        } else
        {
          this.document_attach_list.push(uploadFile);
        }
      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  save(Status) {
    if (this.validateControls()) {
      var formData = this.getForm();
      formData["Status"] = Status;
      formData["UserType"] = this.Content.content.usertype;

      let formData1 = new FormData();
      if (this.document_attach_list != null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }
      formData["Attachment"] =  this.document_attach_list;
      formData1.append("ScreenData", JSON.stringify(formData));

      if (this.Content.content && this.Content.heading === 'Add') {
        this.FileService.FilesInsert('api/rfi/insert', formData1).subscribe(result => {
          if (result.Status === 0) {
            this.commonService.SuccessBanner('RFI ' + formData.TITLE + ' added/submitted successfully');
            this.modalRef.close();
           // this.modalRef.dismiss();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
          }
        })

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.FileService.FilesInsert('api/rfi/update', formData1).subscribe(result => {
          if (result.Status === 0) {
            if (Status == 1){
              this.commonService.SuccessBanner('RFI ' + formData.TITLE + ' details updated successfully');
            }
            else {
              this.commonService.SuccessBanner('RFI ' + formData.TITLE + ' submitted successfully');
            }
            this.modalRef.close();
            //this.modalRef.dismiss();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
          }
        })
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.rfiNewForm.value;

    if (formData.TITLE === null || formData.TITLE === "" || formData.TITLE === undefined) {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Title<br/>";
      isValid = false;
    } else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.DETAILS === null || formData.DETAILS === "" || formData.DETAILS === undefined) {
      $("#DETAILS").addClass("ng-touched ng-invalid validate-error");
      $("#DETAILS").removeClass("ng-untouched ng-valid");
      message += "Please enter Details<br/>";
      isValid = false;
    } else {
      $("#DETAILS").addClass("ng-untouched ng-valid");
      $("#DETAILS").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }

}
